
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.563 13.812a6.25 6.25 0 100-12.5 6.25 6.25 0 000 12.5zM15.688 15.687l-3.706-3.706M4.438 7.562h6.25M7.563 4.437v6.25","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    